module.exports = __webpack_public_path__ + "images/emoji/thumbsup.936acaa12740cd1d4059.png";